const contentful = require('contentful');

const client = contentful.createClient({
  space: 'xr2nrhv1mtt5',
  accessToken: '0tjJtAzKus1odvwjRD8MoD8u83TYn2UIkWb4i5smYs4'
})

export default client
